
import { CompanyLogoUpload } from "./CompanyLogoUpload";

interface CompanyInfoProps {
  companyName: string;
  websiteUrl?: string;
  description?: string;
  logoUrl?: string;
  companyId?: string;
  onLogoClick: () => void;
  onLogoUpdate?: (newLogoUrl: string | null) => void;
}

export function CompanyInfo({
  companyName,
  websiteUrl,
  description,
  logoUrl,
  companyId,
  onLogoClick,
  onLogoUpdate
}: CompanyInfoProps) {
  // Ensure websiteUrl is properly formatted with http/https prefix
  const getFormattedUrl = (url: string) => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    return `https://${url}`;
  };

  return (
    <div className="space-y-4">
      <CompanyLogoUpload 
        companyName={companyName}
        logoUrl={logoUrl}
        companyId={companyId}
        onLogoUpdate={onLogoUpdate}
      />
      <div>
        <h3 className="text-xl font-semibold break-words">{companyName}</h3>
        {websiteUrl && (
          <a 
            href={getFormattedUrl(websiteUrl)}
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-sm text-blue-600 hover:underline break-all"
          >
            {websiteUrl}
          </a>
        )}
        {description && (
          <p className="text-sm text-muted-foreground mt-4 break-words">{description}</p>
        )}
      </div>
    </div>
  );
}
